import { SuretyAccountId } from "@inrev/common";
import { useQuery } from "@tanstack/react-query";
import { useRequest } from "../../../utils/request";
import { bondPreviewsQueryKey } from "../bond.keys";
import { SuretyBondPreview } from "./types";

export const useFetchAccountBondPreviews = (accountId: SuretyAccountId) => {
	const { get } = useRequest();

	const { data, error, isLoading, refetch } = useQuery({
		queryKey: bondPreviewsQueryKey(accountId),
		queryFn: async () =>
			await get<SuretyBondPreview[]>(`/v2/surety/accounts/${accountId}/bonds/previews`),
	});

	return {
		accountBondPreviews: data,
		accountBondPreviewsError: error,
		accountBondPreviewsIsLoading: isLoading,
		refetchAccountBondPreviews: refetch,
	};
};
